import { createSelector } from '@reduxjs/toolkit';

import type { CoreRootState } from '../../CoreStore';

import { selectNetPositionEnabled } from './selectNetPositionEnabled';

export const selectNetPosition = createSelector(
  [selectNetPositionEnabled, ({ gameState }: CoreRootState): number => gameState.netPosition],
  (enabled, netPosition) => {
    return enabled ? netPosition : undefined;
  }
);
